import { UpsellingBanner as F1ProductBanner } from '@factorialco/f0-react'

import i18n from 'modules/core/lib/i18n'

import { UpsellGuard } from 'modules/upselling_kit/components/UpsellGuard'
import { UpsellingKitProductBanner } from 'modules/upselling_kit/types'

import ProductBannerContent from './_Content'

const ProductBanner = ({
  title,
  subtitle,
  mediaUrl,
  primaryAction,
  secondaryAction,
  onClose,
  learnMoreNavigate,
  fallbackComponent,
  loadingComponent,
  ...upsellProps
}: UpsellingKitProductBanner) => {
  return (
    <UpsellGuard
      {...upsellProps}
      fallbackComponent={fallbackComponent || null}
      loadingComponent={
        loadingComponent || (
          <F1ProductBanner
            title={'Loading Banner...'}
            subtitle={'The content is loading...'}
            mediaUrl={'mediaUrl'}
            primaryAction={{
              label: i18n.t('upselling_kit.button.request_information'),
              onClick: () => {},
              variant: 'default',
            }}
            secondaryAction={{
              label: i18n.t('upselling_kit.button.learn_more'),
              onClick: () => {},
              variant: 'default',
            }}
            onClose={() => {}}
            isLoading
          />
        )
      }
    >
      <ProductBannerContent
        {...upsellProps}
        title={title}
        subtitle={subtitle}
        mediaUrl={mediaUrl}
        primaryAction={primaryAction}
        secondaryAction={secondaryAction}
        onClose={onClose}
        learnMoreNavigate={learnMoreNavigate}
      />
    </UpsellGuard>
  )
}

export { ProductBanner }
